module.exports = __webpack_public_path__ + "static/media/jabra-elite-active-65t.10f84cab.jpg";